export default "__VITE_ASSET__DMl1MWQF__"